export const MAAS_COMMAND_ARGS_NORMAL_FIELD_KEYS = {
  shellType: 'mi.initCommand.shellType',
  commands: 'mi.initCommand.commands',
  args: 'mi.initCommand.args',
} as const;

export const MAAS_COMMAND_ARGS_NORMAL_FIELD_KEY_LIST = Object.values(MAAS_COMMAND_ARGS_NORMAL_FIELD_KEYS);
